import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-pagination-url',
  templateUrl: './pagination-url.component.html',
  styleUrls: ['./pagination-url.component.sass']
})
export class PaginationUrlComponent implements OnInit {

  @Input() displayPageSize = true;
  @Input() service: any;
  @Input() pageSize: number;
  @Input() currentRoute = '';
  @Input() refreshOnChangeTotalItems: boolean;
  @Output() items: EventEmitter<Array<any>> = new EventEmitter();
  @Output() loading: EventEmitter<boolean> = new EventEmitter();
  @Output() retPageSize = new EventEmitter();

  get totalItems(): number {
    return this._totalItems;
  }

  @Input()
  set totalItems(value: number) {
    this._totalItems = value;
    if (this._totalItems && this.refreshOnChangeTotalItems && !this.isLoading) {
      this.getData();
    }
  }

  get params(): any {
    return this._params;
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  @Input() set params(params: {} | Promise<any>) {
    this.setParams(params);
  }

  public isLoading = false;
  public pages = [];
  public page = 1;
  public currentPage = 1;
  public totalPages = 1;
  public noRegister = false;

  public hasNext = false;
  public hasPrevious = false;
  public form: FormGroup;
  private _params = {};
  private _totalItems: number;

  constructor() { }

  async ngOnInit() {
    this.createForm();
  }

  async setParams(params) {
    this._params = params;
    this.retPageSize.emit(this.pageSize);
    this.params.page = this.page || 1;
    this.params.currentPage = this.currentPage;
    if (this.params.pageSize === undefined) {
      this.params.pageSize = this.pageSize || 5;
    }
    await this.getData();
  }

  createForm() {
    this.form = new FormGroup({
      pageSize: new FormControl(this.pageSize || 5)
    });
    this.retPageSize.emit(this.pageSize);
    this.form.get('pageSize').valueChanges.subscribe(value => {
      this.pageSize = value;
      this.params.pageSize = value;
      this.page = 1;
      this.params.page = this.page;
      this.getData();
    });
  }

  async getData() {
    this.isLoading = true;
    this.loading.emit(true);
    this.noRegister = false;
    await this.service?.paginate(this.params, this.currentRoute).then(res => {
      if (res.meta) {
        this.currentPage = res.meta.currentPage;
        this.pageSize = res.meta.pageSize;
        this.totalPages = res.meta.totalPages;
        this._totalItems = res.meta.totalItems;
        this.page = res.meta.page;
      } else {
        this.currentPage = this.params.page;
        this.pageSize = this.params.pageSize;
        this.page = this.params.page;
        this.totalPages = Math.ceil(this._totalItems / this.pageSize);
      }
      if (this._totalItems === 0) {
        this.noRegister = true;
      }
      this.pages = [];
      this.retPageSize.emit(this.pageSize);

      for (let i = 0; i < this.totalPages; i++) {
        this.pages.push(i + 1);
      }

      if (this.currentPage > 1) {
        this.hasPrevious = true;
      } else {
        this.hasPrevious = false;
      }

      if (this.currentPage < this.totalPages) {
        this.hasNext = true;
      } else {
        this.hasNext = false;
      }

      this.items.emit(res);

      if (this.totalPages > 1 && this.currentPage > this.totalPages) {
        console.log('backing page', this.currentPage, this.totalPages);
        this.currentPage = this.currentPage - 1;
        this.page = this.currentPage;
        this.params.page = this.currentPage;
        return this.getData();
      }
    });
    this.loading.emit(false);
    this.isLoading = false;
  }

  setPage(page) {
    this.params.page = page;
    this.params.currentPage = page;
    this.getData();
  }

  previous() {
    if (this.currentPage > 1) {
      this.setPage(this.currentPage - 1);
    }
  }

  next() {
    if (this.currentPage < this.totalPages) {
      this.setPage(this.currentPage + 1);
    }
  }

  getSurroundingElements(array, activeIndex) {
    const start = Math.max(0, activeIndex - 3);
    const end = Math.min(array.length - 1, activeIndex + 3);
    return array.slice(start, end + 1);
  }

}
